<template>
    <div class="newPage">
        <div class="content">
            <breadcrumb></breadcrumb>
            <div class="list">
                <div class="item">
                    <div class="header">
                        <div class="title">
                            VOCs重积分数据
                        </div>
                        <div class="center"></div>
                        <a-button class="btn" size="small" type="primary" @click="dataVocList(1)">映射表</a-button>
                        <a-button class="btn" size="small" type="primary" @click="excelexportList(1)">上传记录</a-button>
                    </div>
                    <div class="itemContent">
                        <!-- <div class="formItem">
                             <div class="label">站点名称</div>
                             <div class="value">
                                 <input type="text" v-model="paramsData.station">
                             </div>
                         </div>-->
                        <div class="formItem">
                            <div class="label"> 数据类型</div>
                            <div class="value">
                                <el-radio-group v-model="paramsData.type">
                                    <el-radio :label="0">原始</el-radio>
                                    <el-radio :label="1">审核</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                        <!--<div class="formItem">-->
                        <!--<div class="label"> 数据单位</div>-->
                        <!--<div class="value">-->
                        <!--<el-checkbox-group v-model="checkList">-->
                        <!--<el-checkbox label="ppd"></el-checkbox>-->
                        <!--<el-checkbox label="μg/m3"></el-checkbox>-->
                        <!--</el-checkbox-group>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--<div class="formItem text">-->
                        <!--<div class="label"> 温馨提示</div>-->
                        <!--<div class="value">上传文件必须要上传包含【ppb】和【μg/m3】两个单位数据</div>-->
                        <!--</div>-->
                        <div class="formItem">
                            <div class="label">上传</div>
                            <div class="value">
                                <el-upload
                                        :action="uploadEcxl"
                                        :on-success="handlesuccess"
                                        :on-remove="handleremove"
                                        :limit="1"
                                        :headers="headers"
                                        :data="{type:1}"
                                        :file-list="fileList">
<!--                                    <el-button size="small" type="primary">点击上传</el-button>-->
                                    <a-button size="small" type="primary" class="btn" >点击上传</a-button>
                                </el-upload>
                            </div>
                        </div>
                        <div class="formItem" v-if="flieData">
                            <div class="label">选择导入的tab</div>
                            <div class="value tabBox">
                                <div class="tab" :class="isClass(item.id,1) ? 'active' :'' "
                                     v-for="(item) in flieData.list"
                                     @click="clickTab(item.id,1)"
                                     :key="item.id">{{item.name}}
                                </div>
                            </div>
                        </div>
                        <div class="formItem">
                            <div class="label">操作</div>
                            <!--<div class="btn" @click="exceldownload">模板下载</div>-->
                            <!--<div class="btn" @click="excelExport()">导入</div>-->


                            <a-button size="small" type="primary" class="btn" @click="exceldownload(1)">模板下载</a-button>
                            <a-button size="small" type="primary" class="btn" @click="excelExport()">导入</a-button>
                            <a-button size="small" type="primary" class="btn" @click="tips()">操作说明</a-button>
                        </div>
                    </div>
                </div>

                <div class="item">
                    <div class="header">
                        <div class="title">
                            水溶性离子,OCEC,无机元素
                        </div>
                        <div class="center"></div>
                        <a-button class="btn" size="small" type="primary" @click="dataVocList(2)">映射表</a-button>
                        <a-button class="btn" size="small" type="primary" @click="excelexportList(2)">上传记录</a-button>
                    </div>
                    <div class="itemContent">
                        <!-- <div class="formItem">
                             <div class="label">站点名称</div>
                             <div class="value">
                                 <input type="text" v-model="paramsData.station">
                             </div>
                         </div>-->
                        <div class="formItem">
                            <div class="label"> 数据类型</div>
                            <div class="value">
                                <el-radio-group v-model="paramsData2.type">
                                    <el-radio :label="0">原始</el-radio>
                                    <el-radio :label="1">审核</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                        <div class="formItem">
                            <div class="label">上传</div>
                            <div class="value">
                                <el-upload
                                        :action="uploadEcxl"
                                        :on-success="handlesuccess2"
                                        :on-remove="handleremove2"
                                        :limit="1"
                                        :headers="headers"
                                        :data="{type:2}"
                                        :file-list="fileList2">
                                    <!--                                    <el-button size="small" type="primary">点击上传</el-button>-->
                                    <a-button size="small" type="primary" class="btn" >点击上传</a-button>
                                </el-upload>
                            </div>
                        </div>
                        <div class="formItem" v-if="flieData2">
                            <div class="label">选择导入的tab</div>
                            <div class="value tabBox">
                                <div class="tab" :class="isClass(item.id,2) ? 'active' :'' "
                                     v-for="(item) in flieData2.list"
                                     @click="clickTab(item.id,2)"
                                     :key="item.id">{{item.name}}
                                </div>
                            </div>
                        </div>
                        <div class="formItem">
                            <div class="label">操作</div>
                            <a-button size="small" type="primary" class="btn" @click="exceldownload(2)">模板下载</a-button>
                            <a-button size="small" type="primary" class="btn" @click="excelExport2()">导入</a-button>
<!--                            <a-button size="small" type="primary" class="btn" @click="tips()">操作说明</a-button>-->
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <el-dialog title="上传记录" :visible.sync="open" width="80%" append-to-body>
            <div v-if="tableData">
                <el-table
                        v-loading="loading"
                        size="mini"
                        :data="tableData.list"
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="createUserName"
                            label="上传人"
                    >
                    </el-table-column>
                    <el-table-column
                            label="时间"
                    >
                        <template slot-scope="scope">
                            {{scope.row.createTime | YearDate}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="path"
                            label="上传文件"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="result"
                            label="状态"
                    >
                    </el-table-column>

                </el-table>

                <pagination
                        v-show="tableData.totalCount>0"
                        :total="tableData.totalCount"
                        :page.sync="queryParams.page"
                        :limit.sync="queryParams.pageSize"
                        @pagination="excelexportList()"
                />
            </div>
        </el-dialog>


<!--        映射表-->
        <el-dialog title="映射表" :visible.sync="openDataVoc" width="80%" append-to-body>
            <el-form :inline="true" :model="querydataVocParams">
                <el-form-item>
                    <el-input size="mini" clearable v-model="querydataVocParams.name" placeholder="关键字"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="dataVocList()">查询</el-button>
                </el-form-item>
<!--                <el-form-item v-if="userType==1">-->
<!--                            <el-button type="primary" size="mini" @click="addDataVoc()">新增</el-button>-->
<!--                </el-form-item>-->
            </el-form>
            <div v-if="dataVoctableData">
                <el-table
                        v-loading="loading"
                        size="mini"
                        :data="dataVoctableData.list"
                        border
                        style="width: 100%">
                    <el-table-column prop="name" label="中文名"></el-table-column>
                    <el-table-column prop="ename" label="英文名"></el-table-column>
                    <el-table-column prop="mname" label="java映射名"></el-table-column>
                    <el-table-column prop="oname" label="原始映射名"></el-table-column>
<!--                    <el-table-column-->
<!--                            v-if="userType==1"-->
<!--                            fixed="right"-->
<!--                            label="操作"-->
<!--                            width="140">-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-button type="text" size="small" @click="editDataVoc(scope.row)">编辑</el-button>-->
<!--                            <el-button type="text" size="small" @click="deleteDataVoc(scope.row)">删除</el-button>-->
<!--                        </template>-->
<!--                    </el-table-column>-->

                </el-table>

                <pagination
                        v-show="dataVoctableData.totalCount>0"
                        :total="dataVoctableData.totalCount"
                        :page.sync="querydataVocParams.page"
                        :limit.sync="querydataVocParams.pageSize"
                        @pagination="dataVocList()"
                />
            </div>
        </el-dialog>

<!--        添加 & 修改 弹框-->
        <el-dialog
                :visible.sync="formDialogVisible"
                :title="formData.id?'修改映射表':'增加映射表'"
                width="50%"
        >
            <div>
                <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="中文名" prop="name">
                        <el-input v-model="formData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="英文名" prop="ename">
                        <el-input v-model="formData.ename"></el-input>
                    </el-form-item>
                    <el-form-item label="java映射名" prop="mname">
                        <el-input v-model="formData.mname"></el-input>
                    </el-form-item>
                    <el-form-item label="原始映射名" prop="oname">
                        <el-input v-model="formData.oname"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="formDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')">确认</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>

    import url from "../../../utils/UrlApi"
    import Breadcrumb from "../../../components/breadcrumb";

    export default {
        name: "index",
        components: {Breadcrumb},
        data() {
            return {
                checkList: [],
                fileList: [],
                fileList2: [],
                uploadEcxl: url.uploadEcxl,
                headers: {
                    Authorization: localStorage.getItem('token')
                },
                flieData: null,
                flieData2: null,
                paramsData: {
                    tabList: [],
                    type: 0,
                    station: ''
                },

                paramsData2: {
                    tabList: [],
                    type: 0,
                    station: ''
                },

                open: false,
                queryParams: {
                    page: 1,
                    pageSize: 10
                },
                loading: true,
                tableData: null,

                openDataVoc:false,
                querydataVocParams: {
                    name:'',
                    page: 1,
                    pageSize: 10
                },
                dataVoctableData:null,

            //    映射表 form
                formData:{},
                rules:{
                    name: [
                        {required: true, message: "中文名不能为空", trigger: "blur"}
                    ],
                    ename: [
                        {required: true, message: "英文名不能为空", trigger: "blur"}
                    ],
                    mname: [
                        {required: true, message: "java映射名不能为空", trigger: "blur"}
                    ],
                    oname: [
                        {required: true, message: "原始映射名不能为空", trigger: "blur"}
                    ],

                },
                formDialogVisible: false,
                dataForm: {
                },
            }
        },
        computed: {
            userType: {
                get() {
                    return this.$store.state.userType;
                },
                set(val) {
                    this.$store.commit("updateUserType", val);
                }
            },
        },
        methods: {
            handlesuccess(response, file, fileList) {


                if (response.code === '200') {
                    this.flieData = response.data
                } else {
                    this.$message.error('上传失败')
                    this.fileList = []
                }
            },

            handleremove(file, fileList) {
                this.flieData = null
                this.paramsData.tabList = []
            },

           handlesuccess2(response, file, fileList) {


                if (response.code === '200') {
                    this.flieData2 = response.data
                } else {
                    this.$message.error('上传失败')
                    this.fileList2 = []
                }
            },

            handleremove2(file, fileList) {
                this.flieData2 = null
                this.paramsData.tabList = []
            },


            // 上传记录
            excelexportList(type) {
                console.log(type)
                this.open = true
                this.loading = true;

                if (type){
                    this.queryParams.type = type
                }

                let data = {
                    params: this.queryParams
                }
                this.$http.get(url.excelexportList, data).then(res => {
                    if (res.data.code === '200') {
                        // console.log(res)
                        this.loading = false;
                        this.tableData = res.data.data

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            // 映射表 list
            dataVocList(type){
                this.openDataVoc = true
                this.loading = true;

                if (type){
                    this.querydataVocParams.style = type
                }

                let data = {
                    params: this.querydataVocParams
                }
                this.$http.get(url.dataVocList, data).then(res => {
                    if (res.data.code === '200') {
                        // console.log(res)
                        this.loading = false;
                        this.dataVoctableData = res.data.data

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            tips(){
              // let file = require('../../../assets/file/explain.docx')
                window.open('/file/explain.docx','_blank')
            },

            isClass(id,type) {
                let list = []
                if (type == 1){
                    list = this.paramsData.tabList
                }else {
                    list = this.paramsData2.tabList
                }
                let isTrue = false
                list.forEach(res => {
                    if (res === id) {
                        isTrue = true
                    }
                })

                return isTrue
            },
            clickTab(id,type) {
                let list = []
                if (type == 1){
                    list =  this.paramsData.tabList
                }else {
                    list = this.paramsData2.tabList
                }


                let pos = list.indexOf(id);
                if (pos < 0) {
                    list.push(id)
                } else {
                    list.splice(pos, 1)

                }
            },

            excelExport(cover) {

                let self = this
                if (!this.flieData) {
                    this.$message.error('请先上传文件')
                    return
                }

                let data = {
                    id: this.flieData.id,
                    idx: this.paramsData.tabList,
                    station: this.paramsData.station,
                    type: this.paramsData.type,
                    city: '',
                    cover: cover || ''
                }
                const loading = this.$loading({
                    lock: true,
                    text: '导入中',
                    spinner: 'el-icon-loading',
                });
                this.$http.post(url.excelimport, data).then(res => {
                    loading.close();
                    if (res.data.code === '200') {
                        self.$message.success('导入成功')
                    } else if (res.data.code === '404') {

                        this.$confirm(res.data.message, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            self.excelExport(1)
                        }).catch(() => {
                        });

                    } else {

                        this.$message.error(res.data.message)
                    }
                })
            },

            excelExport2(cover) {

                let self = this
                if (!this.flieData2) {
                    this.$message.error('请先上传文件')
                    return
                }

                let data = {
                    id: this.flieData2.id,
                    idx: this.paramsData2.tabList,
                    station: this.paramsData2.station,
                    type: this.paramsData2.type,
                    city: '',
                    cover: cover || ''
                }
                const loading = this.$loading({
                    lock: true,
                    text: '导入中',
                    spinner: 'el-icon-loading',
                });
                this.$http.post(url.excelimportExcel, data).then(res => {
                    loading.close();
                    if (res.data.code === '200') {
                        self.$message.success('导入成功')
                    } else if (res.data.code === '404') {

                        this.$confirm(res.data.message, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            self.excelExport2(1)
                        }).catch(() => {
                        });

                    } else {

                        this.$message.error(res.data.message)
                    }
                })
            },
            exceldownload(type) {
                window.open(url.exceldownload+'?type='+type, '_blank')
            },


        //     编辑映射表
            editDataVoc(row){
                this.formDialogVisible = true
                this.formData = row
            },

            addDataVoc(){
                this.formDialogVisible = true
                this.formData = {}
            },

        // 删除
            deleteDataVoc(row){
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    let data = {
                        id: row.id
                    }

                    this.$http.post(url.dataVocdelete, data).then(res => {
                        if (res.data.code === '200') {
                            this.dataVocList()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {
                });
            },

            submitForm(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let data =this.formData
                        if (this.formData.id){
                            this.$http.post(url.dataVocupdate, data).then(res => {
                                if (res.data.code === '200') {
                                    // this.download(res.data.data.url)
                                    this.formDialogVisible = false
                                    this.dataVocList()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                        }else {
                            this.$http.post(url.dataVocsave, data).then(res => {
                                if (res.data.code === '200') {
                                    // this.download(res.data.data.url)
                                    this.formDialogVisible = false
                                    this.dataVocList()

                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                        }


                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }


        }
    }
</script>

<style scoped lang="less">
    .newPage {
        .content {
            .list {
                .item {
                    margin: 20px;
                    background-color: #fff;
                    border-radius: 20px;
                    padding: 20px;
                    .header {
                        display: flex;
                        align-items: center;
                        .title {
                        }
                        .center {
                            flex: 1;

                        }
                        .btn {
                            /*background-color: #1daaf1;*/
                            /*color: #fff;*/
                            margin: 0 4px;
                        }
                    }
                    .itemContent {
                        .formItem {
                            display: flex;
                            align-items: center;
                            margin: 10px 0;
                            .label {
                                color: #000;
                                width: 180px;
                            }
                            .value {
                                input[type='text'] {
                                    border: 1px solid #ddd;
                                    padding: 4px 10px;
                                    border-radius: 4px;
                                }
                            }
                            .tabBox {
                                display: flex;
                                .tab {
                                    padding: 8px;
                                    border: 1px solid #ddd;
                                    margin: 0 4px;
                                    border-radius: 6px;
                                    cursor: pointer;
                                }
                                .active {
                                    background-color: #1daaf1;
                                    color: #fff;
                                }
                            }
                            .btn {
                                background-color: #1daaf1;
                                margin-right: 20px;
                                color: #fff;
                            }
                        }
                        .text {
                            color: #409EFF;
                        }
                    }
                }
            }
        }
    }
</style>